var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactlessPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4601 33H9.50869C7.68898 33 6.1875 31.5304 6.1875 29.7491V11.3119C6.1875 9.53074 7.6889 8.06103 9.50869 8.06103H22.4601C24.2798 8.06103 25.7812 9.53066 25.7812 11.3119V29.7491C25.7812 31.5303 24.2799 33 22.4601 33ZM9.50869 31.4856H22.4601C23.461 31.4856 24.2798 30.6841 24.2798 29.7044V11.2673C24.2798 10.2875 23.461 9.48604 22.4601 9.48604H9.50869C8.50776 9.48604 7.68898 10.2875 7.68898 11.2673V29.7044C7.68898 30.6841 8.50776 31.4856 9.50869 31.4856Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fx-theme-path-fill",
    d: "M16.8485 25.0731C18.35 25.0731 19.5785 23.8705 19.5785 22.4009C19.5785 20.9311 18.3502 19.7286 16.8031 19.7286H15.0287C14.3917 19.7286 13.8459 19.1943 13.8459 18.5708C13.8459 17.9473 14.3918 17.413 15.0287 17.413H18.9414V15.9434H16.712V14.8745H15.2106V15.9434H15.0742C13.5727 15.9434 12.3442 17.146 12.3442 18.6156C12.3442 20.0853 13.5728 21.2878 15.0742 21.2878H16.8485C17.4855 21.2878 18.0314 21.8222 18.0314 22.4456C18.0314 23.0691 17.4855 23.6034 16.8485 23.6034H12.8904V25.0731H15.2106V26.1864H16.712V25.0731H16.8485Z",
    fill: "#289643"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fx-theme-path-fill",
    d: "M13.1183 5.83397L11.8898 4.98775C12.8451 3.69641 14.3466 2.89464 15.8937 2.89464C17.5316 2.89464 19.0784 3.69641 19.9883 4.98775L18.7598 5.83397C18.1228 4.89866 17.0765 4.36435 15.9391 4.36435C14.8016 4.36435 13.7553 4.94337 13.1183 5.83397Z",
    fill: "#289643"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fx-theme-path-fill",
    d: "M22.1267 3.11731L20.8982 3.96354C19.7608 2.40477 17.9406 1.46971 15.9844 1.46971C14.0279 1.46971 12.2082 2.40469 11.0707 3.96354L9.84224 3.11731C11.253 1.15781 13.5278 0 15.9845 0C18.4415 0 20.7164 1.15773 22.1267 3.11731Z",
    fill: "#289643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactlessPayment);
export default __webpack_public_path__ + "static/media/contactless-payment.d4b441c2d31d412263737ef186859164.svg";
export { ForwardRef as ReactComponent };